// LEGACY PROVIDER - Now uses ComposedShiftProvider internally
// This file is kept for backward compatibility

import React, { ReactNode } from 'react';
import { ComposedShiftProvider, useShiftManagement as useShiftManagementComposed, useUnifiedShift as useUnifiedShiftComposed, useShiftData as useShiftDataComposed, useIsInfiniteScrollMode as useIsInfiniteScrollModeComposed, useInfiniteScrollShiftData as useInfiniteScrollShiftDataComposed, useInfiniteScrollShiftDataSafe as useInfiniteScrollShiftDataSafeComposed } from './ComposedShiftProvider';

// Legacy interface maintained for backward compatibility
interface UnifiedShiftProviderProps {
  children: ReactNode;
  businessId: string | null;
  initialMonth?: Date;
  onSelectedDateChange?: (date: Date | null) => void;
  /** Enable infinite scroll mode instead of month-based navigation */
  infiniteScrollEnabled?: boolean;
}

// Main provider - now just wraps the ComposedShiftProvider
export const UnifiedShiftProvider: React.FC<UnifiedShiftProviderProps> = (props) => {
  return <ComposedShiftProvider {...props} />;
};

// Legacy hooks - re-export from composed provider for backward compatibility
export const useUnifiedShift = useUnifiedShiftComposed;
export const useShiftManagement = useShiftManagementComposed;
export const useShiftData = useShiftDataComposed;
export const useIsInfiniteScrollMode = useIsInfiniteScrollModeComposed;
export const useInfiniteScrollShiftData = useInfiniteScrollShiftDataComposed;
export const useInfiniteScrollShiftDataSafe = useInfiniteScrollShiftDataSafeComposed;

// Default export for backward compatibility
export default UnifiedShiftProvider;